import { component } from 'picoapp';

export default component(async (node) => {
  const sliderElement = node.querySelector('[data-slider]');
  const config = JSON.parse(node.dataset.sliderConfig || '{}');

  if (!sliderElement) {
    return;
  }

  // Import Swiper
  const { default: Swiper } = await import(
    /* webpackChunkName: "swiper" */ 'modules/swiper'
  );

  // Initialize Swiper with config
  const swiper = new Swiper(sliderElement, config);
  swiper.init();

  // Cleanup function
  if (swiper) {
    swiper.destroy(true, true);
  }
});
